//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Breadcrumb',
  props: ['labels', 'session', 'config'],
  computed: {
    completedSteps() {
      let arr = []
      this.config.forEach((el, index) => {
        if (!!this.session[el.title] && index + 1 !== this.config[this.config.length - 1].step) {
          let obj = el.options.find((opt) => {
            return opt.id === this.session[el.title]
          })
          arr.push([`${el.title}:`, obj.name])
        }
      })
      return arr
    },
  },
  methods: {},
  mounted() {},
}
